import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadLimitModalAlertComponent = _resolveComponent("UploadLimitModalAlertComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("input", {
        type: "file",
        id: "files-input",
        class: "hidden",
        name: "images",
        multiple: false,
        accept: "image/*",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFiles && _ctx.selectFiles(...args))),
        ref: "profile-items-uploader-input"
      }, null, 544),
      _createElementVNode("button", {
        class: _normalizeClass({'w-full rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer': true, 'active-uploading': _ctx.files.length}),
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickSelectFiles && _ctx.clickSelectFiles(...args)), ["prevent"])),
        disabled: _ctx.files.length
      }, [
        (_ctx.files.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('profile_uploader.uploading')), 1))
          : _createCommentVNode("", true),
        (!_ctx.files.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('profile_uploader.upload_button')), 1))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1)
    ]),
    _createVNode(_component_UploadLimitModalAlertComponent, {
      open: _ctx.showUploadLimitModal,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUploadLimitModal = false)),
      type: "profile_limit"
    }, null, 8, ["open"])
  ], 64))
}